var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitedstatesflag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81739 0.5H23.1783C23.9043 0.5 24.4957 1.10208 24.4957 1.84141V16.1542C24.4957 16.8935 23.9043 17.4956 23.1783 17.4956H1.81739C1.0913 17.5 0.5 16.8979 0.5 16.1586V1.84141C0.5 1.10208 1.0913 0.5 1.81739 0.5Z",
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.508696 1.70859H24.4956C24.5 1.75286 24.5043 1.79713 24.5043 1.84583V3.14739H0.5V1.8414C0.5 1.79713 0.504348 1.75286 0.508696 1.70859ZM24.5 4.33827V5.77265H0.5V4.33827H24.5ZM24.5 6.96796V8.40234H0.5V6.96796H24.5ZM24.5 9.59765V11.032H0.5V9.59765H24.5ZM24.5 12.2273V13.6617H0.5V12.2273H24.5ZM24.5 14.857V16.1542C24.5 16.1984 24.4956 16.2471 24.4913 16.2914H0.508696C0.504348 16.2516 0.5 16.2029 0.5 16.1586V14.8615H24.5V14.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54348 0.5V9.65521H0.5V1.84141C0.5 1.10208 1.0913 0.5 1.81739 0.5H9.54348Z",
    fill: "#3C3B6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03427 1.76614L1.33427 2.71797L0.542969 2.12916H1.52558L0.729925 2.71797L1.03427 1.76614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03427 3.60782L1.33427 4.55964L0.542969 3.97084H1.52558L0.729925 4.55964L1.03427 3.60782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03427 5.44949L1.33427 6.40132L0.542969 5.81251H1.52558L0.729925 6.40132L1.03427 5.44949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03427 7.29114L1.33427 8.24296L0.542969 7.65416H1.52558L0.729925 8.24296L1.03427 7.29114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09482 0.845306L2.39917 1.79713L1.60352 1.20833H2.59047L1.79047 1.79713L2.09482 0.845306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09482 2.68698L2.39917 3.6388L1.60352 3.05H2.59047L1.79047 3.6388L2.09482 2.68698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09482 4.52866L2.39917 5.48048L1.60352 4.89168H2.59047L1.79047 5.48048L2.09482 4.52866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09482 6.3703L2.39917 7.32212L1.60352 6.73332H2.59047L1.79047 7.32212L2.09482 6.3703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.09482 8.21198L2.39917 9.1638L1.60352 8.575H2.59047L1.79047 9.1638L2.09482 8.21198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16123 1.76614L3.46557 2.71797L2.66992 2.12916H3.65253L2.85688 2.71797L3.16123 1.76614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16123 3.60782L3.46557 4.55964L2.66992 3.97084H3.65253L2.85688 4.55964L3.16123 3.60782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16123 5.44949L3.46557 6.40132L2.66992 5.81251H3.65253L2.85688 6.40132L3.16123 5.44949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16123 7.29114L3.46557 8.24296L2.66992 7.65416H3.65253L2.85688 8.24296L3.16123 7.29114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22568 0.845306L4.52568 1.79713L3.73438 1.20833H4.71698L3.92133 1.79713L4.22568 0.845306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22568 2.68698L4.52568 3.6388L3.73438 3.05H4.71698L3.92133 3.6388L4.22568 2.68698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22568 4.52866L4.52568 5.48048L3.73438 4.89168H4.71698L3.92133 5.48048L4.22568 4.52866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22568 6.3703L4.52568 7.32212L3.73438 6.73332H4.71698L3.92133 7.32212L4.22568 6.3703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22568 8.21198L4.52568 9.1638L3.73438 8.575H4.71698L3.92133 9.1638L4.22568 8.21198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28623 1.76614L5.59057 2.71797L4.79492 2.12916H5.77753L4.98188 2.71797L5.28623 1.76614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28623 3.60782L5.59057 4.55964L4.79492 3.97084H5.77753L4.98188 4.55964L5.28623 3.60782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28623 5.44949L5.59057 6.40132L4.79492 5.81251H5.77753L4.98188 6.40132L5.28623 5.44949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28623 7.29114L5.59057 8.24296L4.79492 7.65416H5.77753L4.98188 8.24296L5.28623 7.29114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35263 0.845306L6.65698 1.79713L5.86133 1.20833H6.84394L6.04828 1.79713L6.35263 0.845306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35263 2.68698L6.65698 3.6388L5.86133 3.05H6.84394L6.04828 3.6388L6.35263 2.68698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35263 4.52866L6.65698 5.48048L5.86133 4.89168H6.84394L6.04828 5.48048L6.35263 4.52866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35263 6.3703L6.65698 7.32212L5.86133 6.73332H6.84394L6.04828 7.32212L6.35263 6.3703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35263 8.21198L6.65698 9.1638L5.86133 8.575H6.84394L6.04828 9.1638L6.35263 8.21198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41318 1.76614L7.71753 2.71797L6.92188 2.12916H7.90448L7.11318 2.71797L7.41318 1.76614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41318 3.60782L7.71753 4.55964L6.92188 3.97084H7.90448L7.11318 4.55964L7.41318 3.60782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41318 5.44949L7.71753 6.40132L6.92188 5.81251H7.90448L7.11318 6.40132L7.41318 5.44949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41318 7.29114L7.71753 8.24296L6.92188 7.65416H7.90448L7.11318 8.24296L7.41318 7.29114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47763 0.845306L8.78198 1.79713L7.98633 1.20833H8.96894L8.17328 1.79713L8.47763 0.845306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47763 2.68698L8.78198 3.6388L7.98633 3.05H8.96894L8.17328 3.6388L8.47763 2.68698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47763 4.52866L8.78198 5.48048L7.98633 4.89168H8.96894L8.17328 5.48048L8.47763 4.52866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47763 6.3703L8.78198 7.32212L7.98633 6.73332H8.96894L8.17328 7.32212L8.47763 6.3703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47763 8.21198L8.78198 9.1638L7.98633 8.575H8.96894L8.17328 9.1638L8.47763 8.21198Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2980"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 17,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedstatesflag);
export default __webpack_public_path__ + "static/media/unitedstatesflag.2ede3f9ad023201b14986e636a9399dc.svg";
export { ForwardRef as ReactComponent };